/* Golf course video */
import fitvids from 'fitvids';
import Player from '@vimeo/player';

export function golf_course_video() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--golf-course-video' ).length <= 0 ) {
				return;
			}

			fitvids( '.block--golf-course-video .block--golf-course-video--iframe--wrapper' );

			const stopAllVideos = () => {
				$( '.block--golf-course-video--iframe--wrapper' ).each( ( ind, ele ) => {
					$( ele ).find( '.controls' ).addClass( 'paused' );
					const video = $( ele ).find( 'iframe' )[0];
					const player = new Player( video );

					player.pause();
				} );	
			}

			$( '.block--golf-course-video--iframe--wrapper' ).each( ( ind, ele ) => {
				const video		= $( ele ).find( 'iframe' )[0];
				const controls	= $( ele ).find( '.controls' );
				const player	= new Player( video );

				controls.one( 'click', ( ev ) => {
					stopAllVideos();
					player.play();
					controls.addClass( 'paused' );
				} );

				player.on( 'play', () => {
					controls.one( 'click', ( ev ) => {
						player.pause();
					} ).removeClass( 'paused' );
				} );

				player.on( 'pause', () => {
					controls.one( 'click', ( ev ) => {
						stopAllVideos();
						player.play();
					} ).addClass( 'paused' );	
				} );

			} );
		}

		init();

	} )( window.jQuery );
}